(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-product"]) return;
  try {
    
  if (!customElements.get('bm-product')) {
    customElements.define('bm-product', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.querySelector('[data-variant-select]').addEventListener('change', event => this.updateVariant(event.target.value));
        this.querySelectorAll('[data-image-src]').forEach(button => button.addEventListener('click', () => this.updateImage(button.dataset.imageSrc, button.dataset.imageAlt, button.dataset.imageId)));
      }
      updateImage(src, alt, imageId) {
        const image = this.querySelector('.bm-product__main-image');
        if (!image || !src) return;
        image.removeAttribute('srcset');
        image.src = src;
        image.alt = alt || '';
        this.querySelectorAll('[data-image-src]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.imageId === String(imageId))));
      }
      updateVariant(id) {
        const variant = this.variants[id];
        if (!variant) return;
        this.querySelector('[data-price]').textContent = variant.price;
        const compare = this.querySelector('[data-compare-price]');
        compare.textContent = variant.compare || '';
        compare.hidden = !variant.compare;
        this.querySelector('[data-availability]').textContent = variant.available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
        const button = this.querySelector('[data-add-button]');
        button.disabled = !variant.available;
        button.textContent = variant.available ? this.dataset.addLabel : this.dataset.unavailableLabel;
        const quantity = this.querySelector('[data-quantity]');
        quantity.min = variant.min;
        quantity.step = variant.step;
        if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
        quantity.value = variant.min;
        this.updateImage(variant.image, variant.alt, variant.imageId);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
